import React from "react"
import "./WebMention.scss"

import HeartIcon from "./icons/darkheart.svg"
import ChatIcon from "./icons/chat.svg"
import RetweetIcon from "./icons/refresh.svg"

import TimeAgo from "javascript-time-ago"
// Load locale-specific relative date/time formatting rules.
import en from "javascript-time-ago/locale/en"

// Add locale-specific relative date/time formatting rules.
TimeAgo.addLocale(en)

// Create relative date/time formatter.
const timeAgo = new TimeAgo("en-US")

export default function WebMentions({ edges }) {
  const [showWebmentions, setShowWebmentions] = React.useState(false)

  const reposts = edges
    .filter(({ node }) => node.wmProperty === "repost-of")
    .map(
      ({ node }) =>
        node.author && {
          wmId: node.wmId,
          url: node.url,
          name: node.author.name,
          photo: node.author.photo,
        }
    )

  const likes = edges
    .filter(({ node }) => node.wmProperty === "like-of")
    .map(({ node }) => node.author && { wmId: node.wmId, ...node.author })

  const comments = edges
    .filter(
      ({ node }) =>
        node.wmProperty === "mention-of" || node.wmProperty === "in-reply-to"
    )
    .map(
      ({ node }) =>
        node.content && {
          wmProperty: node.wmProperty,
          wmId: node.wmId,
          url: node.url,
          author: node.author,
          published: node.published,
          ...node.content,
        }
    )

  const hasWebMentions =
    comments.length > 0 || reposts.length > 0 || likes.length > 0
  const hasComments = comments.length > 0 || reposts.length > 0
  return (
    <div>
      {hasWebMentions && webMentionsHeader(reposts, comments)}

      {hasComments && (
        <button
          className="toggle-webmentions"
          onClick={() => setShowWebmentions(!showWebmentions)}
        >
          {showWebmentions ? "Hide Mentions" : "Show Mentions"}
        </button>
      )}
      {likes.length > 0 && likesAvatars(likes)}

      {showWebmentions && (
        <>
          {" "}
          {commentsWebMentions(comments)}
          {repostWebMentions(reposts)}
        </>
      )}
    </div>
  )
}

const MAX_AVATARS_TO_DISPLAY = 40

function likesAvatars(likes) {
  return (
    <>
      <div className="avatars">
        {likes.length > 0 && (
          <img src={HeartIcon} alt="Heart" className="engagement-icon" />
        )}
        {likes &&
          likeAvatars(likes.slice(0, MAX_AVATARS_TO_DISPLAY), likes.length)}
      </div>
    </>
  )
}
function webMentionsHeader(reposts, mentions) {
  return (
    <React.Fragment>
      <h2 className="webMentions-header">Webmentions</h2>{" "}
      {reposts.length > 0 && (
        <>
          <img
            src={RetweetIcon}
            alt="Retweet Icon"
            className="engagement-icon"
          />

          {`${reposts.length}`}
        </>
      )}
      {mentions.length > 0 && (
        <>
          <img src={ChatIcon} alt="Chat Bubbles" className="engagement-icon" />
          {`${mentions.length}`}
        </>
      )}
    </React.Fragment>
  )
}

function likeAvatars(avatars, likes) {
  return (
    <ul className="avatars">
      {" "}
      {avatars.map(author => (
        <li key={author.wmId}>
          <a href={author.url}>
            <img
              alt={author.name}
              src={author.photo}
              key={`${author.wmId}-photo`}
              className="avatar"
            />
          </a>
        </li>
      ))}
      <li>
        {" "}
        {likes - avatars.length > 0 && (
          <p className="plusAvatars">{`+${likes - avatars.length}`}</p>
        )}
      </li>
    </ul>
  )
}
function commentsWebMentions(comments) {
  return comments.map(comment => (
    <p key={`${comment.wmId}-comment`} className="webmention-comment">
      {" "}
      <a href={comment.url} className="comment-url">
        <img
          alt={comment.author.name}
          src={comment.author.photo}
          className="avatar"
        />
      </a>{" "}
      {comment.author.name}{" "}
      <a href={comment.url}>
        {" "}
        {comment.wmProperty === "in-reply-to" && "replied"}{" "}
        {comment.wmProperty === "mention-of" && "shared"}
      </a>{" "}
      {timeAgo.format(new Date(comment.published))}
      : <br /> "{comment.text}"
    </p>
  ))
}
function repostWebMentions(reposts) {
  return reposts.map(repost => (
    <p key={`${repost.wmId}-comment`} className="webmention-comment">
      <a href={repost.url} className="comment-url">
        <img alt={repost.name} src={repost.photo} className="avatar" />
      </a>
      {repost.name} <a href={repost.url}>retweeted</a>
    </p>
  ))
}
